/**
*
* Topics
*
*/

import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import usePolling from 'utils/usePolling.js';
import { useSearch } from 'utils/urlUtils.js';
import SearchTopics from './SearchTopics.jsx';
import SubTopics from './SubTopics.jsx';
import MainTopics from './MainTopics.jsx';
import ArchiveTopics from './ArchiveTopics.jsx';
import useUpdateTopics from '../useUpdateTopics.js';
import { TOPICS_POLL } from '../constants.jsx';
import useConversationsContext from '../useConversationsContext.js';

function Topics() {
  const { parentTopic, archive, baseUrl, topics, setTopics } = useConversationsContext();
  const navigate = useNavigate();
  const { inboxId } = useParams();
  const { q } = useSearch();
  const updateTopics = useUpdateTopics({ baseUrl, topics, setTopics });
  const timestamp = topics.nextSince || topics.timeStamp;
  usePolling(updateTopics, timestamp ? TOPICS_POLL : null);

  if (parentTopic) {
    return <SubTopics />;
  }
  if (q) {
    return <SearchTopics onCancel={() => navigate(`/conversations/inboxes/${inboxId}`, { replace: true })} />;
  }
  return archive ? <ArchiveTopics /> : <MainTopics />;
}

export default Topics;
